import script from "./BasicLayouts.vue?vue&type=script&setup=true&lang=ts"
export * from "./BasicLayouts.vue?vue&type=script&setup=true&lang=ts"

import "./BasicLayouts.vue?vue&type=style&index=0&id=fbb57c80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbb57c80"]])

export default __exports__